import { render, staticRenderFns } from "./OrderListCard.vue?vue&type=template&id=0aa41c3e"
import script from "./OrderListCard.vue?vue&type=script&lang=js"
export * from "./OrderListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports